import RequestAbstract from "./RequestAbstract";

const isNumber = (str) => {
    return !!(str || "").match(/^[\d|+]+$/);
};

const checkIsPhone = (str) => {
    let result = str.replace(/\s+/g, '');
    if (result.length < 13) {
        const isValid = /^[+\d]+$/.test(result);
        if (isValid)
            return true;
    }

    return false;
};

export default class Clients extends RequestAbstract {
    get link() {
        return this.links.clients;
    }

    async searchByCondition(conditions, count = 500, sortKey) {
        console.log("searchByCondition", conditions, count);

        const arr = [];
        conditions.forEach(condition => {
            arr.push(condition);
        });
        //return this.getAllFiltered([arr], this.getSortField(["lname", "fname", "sname"]));
        //return this.search(count, arr, this.getSortField(sortKey));
        const req = await this.getFiltered(this.link, [arr], [], {
            page: 0,
            pageSize: count
        });
        return req;
    }

    async searchByNamePhone(value, count, sortKey = "id", withProfId = false) {
        const cond = [];
        if (!value)
            return;

        if (checkIsPhone(value)) {
            value = value.replace(/\s+/g, '');
            if (value.startsWith('8')) {
                value = value.replace(/^8/, '+7');
            }
        }

        const values = value.trim().split(" ");

        let phone = "";

        for (let i in values) {
            if (isNumber(values[i])) {
                phone = values[i];
                values.splice(i, 1);
                break;
            }
        }

        const lname = values[0] || "";
        const fname = values[1] || "";

        const act = { field: "isActive", op: "=", value: true };
        const fObj = { field: "fname", op: ":", value: fname };
        const lObj = { field: "lname", op: ":", value: lname };
        const pObj = { field: "phoneNumber", op: ":", value: phone.replace("+", "") };

        if (withProfId && value.length > 2)
            cond.push([act, { field: "profileNumber", op: ":", value }]);
        if (fname && lname && phone)
            cond.push([act, lObj, fObj, pObj]);
        else if (fname && lname)
            cond.push([act, lObj, fObj]);
        else if (lname && phone)
            cond.push([act, lObj, pObj]);
        else if (lname)
            cond.push([act, lObj]);
        else if (phone)
            cond.push([act, pObj]);

        if (!sortKey)
            sortKey = "id";

        if (!cond.length)
            cond.push([act]);

        return this.search(count, cond, this.getSortField(sortKey));
    }

    async getDetails(id) {
        return this.get(this.links.clientsDetails + "/" + id);
    }
}
